const STORAGE_KEY = 'stunservers'

export default {
  get () {
    const stunServers = localStorage.getItem(STORAGE_KEY)
    return stunServers
  },

  set (stunServers) {
    localStorage.setItem(STORAGE_KEY, stunServers)
  }
}
